import CardItem from "../components/Cards/CardItem";
import "../components/Cards/CardItem.css";
import blogConfig from "../assets/configs/blogConfig"

import homeConfig from "../assets/configs/homeConfig";
import About from "../components/About";
import {Container, Row, Col} from "react-bootstrap";
import "./Home/Home.css"

const Blogs = () => {
    return (
        <>
        <p> </p>
        <section>
            <Container fluid className="home-content" id="home">
                <Row>
                    <Col className="home-header">
                        <div>
                            <About about={homeConfig.blogabout}/>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>

        <div className="wrapper">
            {blogConfig.map((item) => (
                <CardItem item={item}/>
                )
                )}
        </div>
        </>
        )
}

export default Blogs